import { Component, Renderer2, OnInit } from '@angular/core'
import { bxSearchUrl, cxDomain } from '../../common/utilities/constants'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { UserAuthService } from '../../services/user-auth.service'
@Component({
    selector: 'app-header',
    imports: [RouterModule, CommonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  cxDomain = cxDomain
  bxHeader: boolean = false

  constructor (private readonly renderer: Renderer2, private readonly userAuthService: UserAuthService) {}

  ngOnInit (): void {
    const previousPageUrl = decodeURIComponent(this.userAuthService.getCookie('previousPageUrl') || '')
    const bookingType = sessionStorage.getItem('bookingType') || ''
    if (previousPageUrl?.includes(bxSearchUrl) || (bookingType === 'minor')) {
      this.bxHeader = true
      this.renderer.addClass(document.body, 'bx-header-enabled')
    } else {
      this.renderer.removeClass(document.body, 'bx-header-enabled')
    }
  }
}
